export const IconArrowRightGoTo10: {
  name: 'icon_arrow_right_go_to_10-a36425ed5a29'
} = {
  name: 'icon_arrow_right_go_to_10-a36425ed5a29'
}
